import NsContent from 'components/common/ns-content/NsContent';
import NsHeader from '@britishgasenergy/react-nucleus/dist/nuc-components/NsHeader';
import NsxFooter from '@britishgasenergy/react-nucleus/dist/nuc-components/NsxFooter';

import { NsPanel } from 'components/common/ns-panel/NsPanel';

export const testId = 'maintenancePageTestId';

export const Maintenance = () => {
  return (
    <>
      <NsHeader hide-links />
      <main id="#content">
        <NsPanel testId={testId}>
          <NsContent>
            <h1>Please come back later</h1>
            <p>
              Unfortunately, we&apos;re having technical problems at the moment.
              Please try again later.
            </p>
            <p>
              Thank you for your patience, We&apos;re sorry for the
              inconvenience this might cause.
            </p>
          </NsContent>
        </NsPanel>
      </main>
      <NsxFooter />
    </>
  );
};
